import { render, staticRenderFns } from "./FacebookLive.vue?vue&type=template&id=549854b4&scoped=true"
import script from "./FacebookLive.vue?vue&type=script&lang=js"
export * from "./FacebookLive.vue?vue&type=script&lang=js"
import style0 from "./FacebookLive.vue?vue&type=style&index=0&id=549854b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549854b4",
  null
  
)

export default component.exports